// extracted by mini-css-extract-plugin
export default {"wrap":"TextPlay_wrap__KZ5tr","title":"TextPlay_title__QOE9d","body":"TextPlay_body__S7g+S"};